import { ApiRequest, RequestMethod } from "../../request";

export async function editFighterNotes(fighterId: string, notes: string): Promise<boolean> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(`/api/fighter/${fighterId}/notes`);
    apiRequest.setJsonBody({ notes });

    const response: any = await apiRequest.send();
    return response.status === 200;
}
